/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SendingFacilityViewModel {
  id?: string;
  datasetId?: string;
  facilityName?: string | null;
  performUpdates?: boolean;
  isChargeCentralActivated?: boolean;
  duplicatePatientCheck?: boolean;
  mergeProcedures?: boolean;
  patientIsGuarantor?: boolean;
}
